export function currentUserStateSelector(state) {
  return state.local.currentUser
}

export function loginStateSelector(state) {
  return currentUserStateSelector(state).login
}
